module.exports = __webpack_public_path__ + "static/media/uploaduser.a4d7493e.png";